import { plainToClass } from "class-transformer";
import { InitializeFilterDropdown } from "../../../../shared/scripts/filtering/filtering.utilities";
import { Unique } from "../../../../shared/scripts/array-functions";
import { AuditHistoryDialog } from "../../audit/scripts/audit-history.dialog";

export class CTMSUserDetailsPage {
    userId: number;
    token: string;
    userDetails: any;
    mySites: any[];
    checkedSiteIds: Set<number> = new Set();
    allSiteSettings: any[] = [];
    assignedSites: number[] = [];
    editUserSitesTable: any;
    mySitesTable: any;
    auditHistoryDialog: AuditHistoryDialog;

    constructor(userId: number, mySitesJson: any) {
        $(() => {
            this.token = document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value');
            this.userId = userId;
            this.mySites = mySitesJson || [];
            this.auditHistoryDialog = new AuditHistoryDialog();
            this.initializeModal();
            this.setupEditUserDialog();
            this.setupAuditHistoryIcons();
            this.initMySitesTable();
            this.setupEditUserSiteButton();
            this.setupSaveUserSiteAssignment();
            $('#editUserSiteDialog').on('shown.bs.modal', () => {
                if (this.editUserSitesTable) {
                    this.editUserSitesTable.columns.adjust();
                }
            });
        });
    }

    initializeModal() {
        $('#editUserDialog').on('show.bs.modal', () => {
            const name = $('#userDetailsName').text().trim();
            const email = $('#userDetailsEmail').text().trim();
            const phone = $('#userDetailsPhone').text().trim();
            $('#editUserDialog input[name="Name"]').val(name);
            $('#editUserDialog input[name="Email"]').val(email);
            $('#editUserDialog input[name="PhoneNumber"]').val(phone);
        });
    }

    setupEditUserDialog() {
        const self = this;
        $('#editUserDialog').modal({
            backdrop: 'static',
            show: false
        });
        $('#editUserDialog').on('hidden.bs.modal', () => {
            $('#userDialogForm').removeClass('ctms-invalid-form');
        });

        $('#editUserDialog .ctms-button-save').off('click').on('click', function (e) {
            const f = document.getElementById('userDialogForm') as HTMLFormElement;
            if (f.checkValidity()) {
                $('#userDialogForm').removeClass('ctms-invalid-form');
                const formData = $('#editUserDialog .ctms-field-submit').serialize();
                $('#editUserDialog .ctms-button-save').prop('disabled', true);
                $('#editUserSaveSpinner').show();
                $.ajax({
                    url: `/secure/ctms/settings/user-details?handler=UpdateUserDetails&id=${self.userId}`,
                    headers: { "RequestVerificationToken": self.token },
                    type: 'POST',
                    data: formData,
                    success: function (resp) {
                        if (resp && resp.Name) {
                            // Update breadcrumb
                            $(".ctms-breadcrumb-detail").text(' ' + resp.Name);

                            // Reload the entire user details section
                            self.loadUserDetailsSection();
                        }
                        $('#editUserDialog').modal('hide');
                    },
                    error: function () {
                        alert('Error updating user details.');
                        f.reset();
                        $('#editUserDialog').modal('hide');
                    },
                    complete: function () {
                        $('#editUserDialog .ctms-button-save').prop('disabled', false);
                        $('#editUserSaveSpinner').hide();
                    }
                });
            } else {
                $('#userDialogForm').addClass('ctms-invalid-form');
            }
            e.preventDefault();
            e.stopPropagation();
        });
    }

    setupAuditHistoryIcons() {
        const self = this;
        $('#editUserDialog').on('click', '.ctms-audit-icon[data-audit-field]', function () {
            const fieldName = $(this).data('audit-field');
            const fieldLabel = $(this).data('audit-label');
            const entityType = 'CTMSUser';
            const entityId = self.userId;

            if (self.auditHistoryDialog && fieldName && entityId) {
                self.auditHistoryDialog.show(entityType, entityId, fieldName, fieldLabel);
            }
        });
    }

    async loadUserDetailsSection() {
        const response = await fetch(
            `/secure/ctms/settings/user-details?handler=UserDetailsSection&id=${this.userId}`,
            {
                method: 'GET',
                headers: { "RequestVerificationToken": this.token },
            }
        );
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        const result = await response.text();
        document.querySelector('#userDetailsSection').innerHTML = result;
    }

    initMySitesTable() {
        this.mySitesTable = $('#my-sites-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '40vh',
            scrollCollapse: true,
            orderCellsTop: true,
            columns: [
                { data: 'SiteNumber', title: 'Site Number', width: '120px' },
                { data: 'SiteName', title: 'Site Name' }
            ],
            order: [[0, 'asc']],
            data: this.mySites
        });
    }

    setupEditUserSiteButton() {
        const self = this;
        $('#editUserSiteButton').off('click').on('click', function () {
            $.ajax({
                url: `/secure/ctms/settings/user-details?handler=SiteSettingsDto&id=${self.userId}`,
                method: 'GET',
                headers: { "RequestVerificationToken": self.token },
                success: function (resp) {
                    if (resp && resp.success && resp.userSite) {
                        self.allSiteSettings = mapKeysToPascalCase(resp.userSite.allSites) || [];
                        self.assignedSites = resp.userSite.assignedSites || [];
                        self.checkedSiteIds = new Set(self.assignedSites);
                        self.showEditUserSitesModal();
                        if (self.editUserSitesTable) self.editUserSitesTable.draw();
                    } else {
                        alert('Could not load site settings.');
                    }
                },
                error: function () {
                    alert('Error loading site settings.');
                }
            });
        });
    }

    showEditUserSitesModal() {
        const self = this;
        if (self.editUserSitesTable) {
            self.editUserSitesTable.destroy();
            $('#edit-user-sites-table').empty();
        }
        self.editUserSitesTable = $('#edit-user-sites-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '40vh',
            scrollCollapse: true,
            orderCellsTop: true,
            columns: [
                {
                    data: null,
                    title: '<input type="checkbox" id="edit-user-sites-header-checkbox" />',
                    className: "ctms-table-col-check",
                    orderable: false,
                    render: function (data, type, row) {
                        return `<input type="checkbox" class="assign-site-checkbox" data-id="${row.Id}" />`;
                    }
                },
                { data: 'SiteNumber', title: 'Site Number', width: '120px' },
                { data: 'SiteName', title: 'Site Name' }
            ],
            order: [[1, 'asc']],
            data: self.allSiteSettings
        });

        $('#edit-user-sites-header-checkbox').on('change', function () {
            const isChecked = $(this).prop('checked');

            self.editUserSitesTable.rows({ search: 'applied' }).every(function () {
                const rowData = this.data();
                const $row = $(this.node());
                const $checkbox = $row.find('.assign-site-checkbox');

                if (isChecked) {
                    self.checkedSiteIds.add(rowData.Id);
                    $checkbox.prop('checked', true);
                } else {
                    self.checkedSiteIds.delete(rowData.Id);
                    $checkbox.prop('checked', false);
                }
            });
        });

        $('#filter-userSite-search-input').on('input', function () {
            $('#edit-user-sites-table').DataTable().search(String($(this).val() ?? '')).draw();
        });
        $('#filter-userSite-search-clear').on('click', function () {
            $('#filter-userSite-search-input').val('');
            $('#edit-user-sites-table').DataTable().search('').draw();
        });
        // Listen for checkbox changes
        $('#edit-user-sites-table tbody').on('change', '.assign-site-checkbox', function () {
            const id = Number($(this).attr('data-id'));
            if ($(this).prop('checked')) {
                self.checkedSiteIds.add(id);
            } else {
                self.checkedSiteIds.delete(id);
            }
            self.updateUserSitesTableHeaderCheckboxState();
        });
        // On table draw, restore checked state
        self.editUserSitesTable.on('draw', function () {
            self.editUserSitesTable.rows().every(function () {
                const $row = $(this.node());
                const rowData = this.data();
                const $checkbox = $row.find('.assign-site-checkbox');
                if ($checkbox.length && self.checkedSiteIds.has(rowData.Id)) {
                    $checkbox.prop('checked', true);
                } else {
                    $checkbox.prop('checked', false);
                }
            });
            self.updateUserSitesTableHeaderCheckboxState();
        });
        $('#editUserSiteDialog').modal({
            backdrop: 'static',
            show: true
        });
    }

    updateUserSitesTableHeaderCheckboxState(): void {
        const $headerCheckbox = $('#edit-user-sites-header-checkbox');
        const visibleRows: any[] = [];

        this.editUserSitesTable.rows({ search: 'applied' }).every(function () {
            visibleRows.push(this.data());
        });

        if (visibleRows.length === 0) {
            $headerCheckbox.prop('checked', false);
            $headerCheckbox.prop('indeterminate', false);
            return;
        }

        const checkedCount = visibleRows.filter(row => this.checkedSiteIds.has(row.Id)).length;

        if (checkedCount === 0) {
            $headerCheckbox.prop('checked', false);
            $headerCheckbox.prop('indeterminate', false);
        } else if (checkedCount === visibleRows.length) {
            $headerCheckbox.prop('checked', true);
            $headerCheckbox.prop('indeterminate', false);
        } else {
            $headerCheckbox.prop('checked', false);
            $headerCheckbox.prop('indeterminate', true);
        }
    }

    setupSaveUserSiteAssignment() {
        const self = this;
        $('#saveUserSiteAssignment').off('click').on('click', function () {
            $('#saveUserSiteAssignment').prop('disabled', true);
            $('#userSiteAssignmentSaveSpinner').show();
            const assignedSites = Array.from(self.checkedSiteIds);
            const formData = new FormData();
            formData.append('Id', String(self.userId));
            formData.append('AssignedSites', JSON.stringify(assignedSites));
            $.ajax({
                url: `/secure/ctms/settings/user-details?handler=SaveUserSite`,
                method: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: formData,
                headers: { "RequestVerificationToken": self.token },
                success: function (resp) {
                    if (resp && resp.success && resp.userSites) {
                        self.updateMySitesTable(resp.userSites);
                        $('#editUserSiteDialog').modal('hide');
                    } else {
                        alert('Could not save site assignment.');
                    }
                },
                error: function () {
                    alert('Error saving site assignment.');
                },
                complete: function () {
                    $('#saveUserSiteAssignment').prop('disabled', false);
                    $('#userSiteAssignmentSaveSpinner').hide();
                }
            });
        });
    }

    updateMySitesTable(newSites: any[]) {
        this.mySites = mapKeysToPascalCase(newSites) || [];
        if (this.mySitesTable) {
            this.mySitesTable.clear();
            this.mySitesTable.rows.add(this.mySites).draw();
        }
    }
}

function mapKeysToPascalCase(obj: any): any {
    if (Array.isArray(obj)) {
        return obj.map(mapKeysToPascalCase);
    }
    if (obj !== null && typeof obj === 'object') {
        const newObj: any = {};
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
                newObj[pascalKey] = mapKeysToPascalCase(obj[key]);
            }
        }
        return newObj;
    }
    return obj;
}